module.exports = __webpack_public_path__ + "img/45.tag_cleaner.7f9a5966.svg";